// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file tasks/tasks.proto (package lvdr.v2.tasks, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { LimitCut } from "../errors/errors_pb";
import { file_errors_errors } from "../errors/errors_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tasks/tasks.proto.
 */
export const file_tasks_tasks: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_errors_errors]);

/**
 * Back-reference from a task to another LVDR entity (a research project, a
 * note, a knowledge node, or a sweep-produced artifact).
 *
 * @generated from message lvdr.v2.tasks.TaskLink
 */
export type TaskLink = Message<"lvdr.v2.tasks.TaskLink"> & {
  /**
   * "research" | "note" | "knowledge" | "artifact" | "interaction" | "interaction_removed"
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;
};

/**
 * Describes the message lvdr.v2.tasks.TaskLink.
 * Use `create(TaskLinkSchema)` to create a new message.
 */
export const TaskLinkSchema: GenMessage<TaskLink> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 0);

/**
 * @generated from message lvdr.v2.tasks.Task
 */
export type Task = Message<"lvdr.v2.tasks.Task"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskStatus status = 4;
   */
  status: TaskStatus;

  /**
   * @generated from field: lvdr.v2.tasks.TaskPriority priority = 5;
   */
  priority: TaskPriority;

  /**
   * optional; unset = no due date
   *
   * @generated from field: google.protobuf.Timestamp due = 6;
   */
  due?: Timestamp | undefined;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * @generated from field: lvdr.v2.tasks.TaskSource source = 8;
   */
  source: TaskSource;

  /**
   * @generated from field: repeated lvdr.v2.tasks.TaskLink links = 9;
   */
  links: TaskLink[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * COS-03 time-block. estimate_min is the expected duration (0 = unset).
   * scheduled_start/end are the planner's assigned block for the current day
   * (unset = not scheduled) — written only by the time-block planner, never the
   * update path.
   *
   * @generated from field: uint32 estimate_min = 12;
   */
  estimateMin: number;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_start = 13;
   */
  scheduledStart?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_end = 14;
   */
  scheduledEnd?: Timestamp | undefined;

  /**
   * TASKS-05 recurrence. Empty series_id = a hand-authored task, which is the
   * overwhelming majority. When set, this task was materialised from the series
   * of that id and `occurrence` is its SPAWN INDEX within that series — not the
   * count of elapsed periods, which diverges after any catch-up.
   *
   * @generated from field: string series_id = 15;
   */
  seriesId: string;

  /**
   * @generated from field: uint32 occurrence = 16;
   */
  occurrence: number;

  /**
   * COS-23: how much focus the task needs; UNSPECIFIED = not set.
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel attention_level = 17;
   */
  attentionLevel: TaskAttentionLevel;

  /**
   * unset = not snoozed; a past instant = not snoozed
   *
   * @generated from field: google.protobuf.Timestamp snoozed_until = 18;
   */
  snoozedUntil?: Timestamp | undefined;

  /**
   * COS-26. Set only while a suggestion is PENDING for the current title + notes;
   * UNSPECIFIED = none. Never read as the task's level (D21).
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel suggested_attention_level = 19;
   */
  suggestedAttentionLevel: TaskAttentionLevel;

  /**
   * @generated from field: google.protobuf.Timestamp attention_suggested_at = 20;
   */
  attentionSuggestedAt?: Timestamp | undefined;

  /**
   * The last suggestion the user rejected; UNSPECIFIED = none.
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel rejected_attention_level = 21;
   */
  rejectedAttentionLevel: TaskAttentionLevel;

  /**
   * LIMIT-34: what inbox enrichment could not add (field, limit, unit, original). Empty = nothing cut.
   *
   * @generated from field: repeated lvdr.v2.errors.LimitCut truncated = 22;
   */
  truncated: LimitCut[];
};

/**
 * Describes the message lvdr.v2.tasks.Task.
 * Use `create(TaskSchema)` to create a new message.
 */
export const TaskSchema: GenMessage<Task> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 1);

/**
 * Recurrence is a typed generator, deliberately NOT an RFC 5545 RRULE string:
 * the repo has no RRULE writer, and validation over typed fields is far stronger
 * than over a string — which matters because this message is LLM-settable
 * through MCP create_task, i.e. a security boundary.
 *
 * @generated from message lvdr.v2.tasks.Recurrence
 */
export type Recurrence = Message<"lvdr.v2.tasks.Recurrence"> & {
  /**
   * @generated from field: lvdr.v2.tasks.RecurrenceAnchor anchor = 1;
   */
  anchor: RecurrenceAnchor;

  /**
   * @generated from field: lvdr.v2.tasks.RecurrenceFreq freq = 2;
   */
  freq: RecurrenceFreq;

  /**
   * 1..366. 366 lets "every N days" express a full leap year and nothing beyond.
   *
   * @generated from field: uint32 interval = 3;
   */
  interval: number;

  /**
   * The TARGET weekday set for WEEKLY, not an offset. 0 = Sunday .. 6 = Saturday
   * — the same numbering as Go's time.Weekday and JS getDay(), so no layer
   * renumbers. The server sorts and de-duplicates on write.
   *
   * @generated from field: repeated uint32 weekdays = 4;
   */
  weekdays: number[];

  /**
   * Target day-of-month for MONTHLY, 1..31. A value past the end of a short
   * month is CLAMPED PER PROJECTION and never written back, so 31 yields
   * Jan 31 -> Feb 28 -> Mar 31, not Mar 28.
   *
   * @generated from field: uint32 month_day = 5;
   */
  monthDay: number;

  /**
   * REQUIRED canonical IANA name, e.g. "Pacific/Auckland". A marshalled
   * timestamp carries a fixed OFFSET, not a zone, so a fixed-offset series
   * re-phases by an hour at each DST transition and a weekday target resolved
   * from the wrong zone is wrong once and then wrong forever. Go's magic
   * "Local" is REJECTED — it would anchor the series to whichever backend
   * materialised it.
   *
   * @generated from field: string timezone = 6;
   */
  timezone: string;

  /**
   * Phase anchor, interpreted IN timezone. Its clock time is preserved across
   * every projection.
   *
   * @generated from field: google.protobuf.Timestamp start = 7;
   */
  start?: Timestamp | undefined;

  /**
   * Optional end bound. Unset = no end (valid: "every Tuesday, forever").
   *
   * @generated from field: google.protobuf.Timestamp until = 8;
   */
  until?: Timestamp | undefined;

  /**
   * Optional occurrence bound; 0 = unbounded.
   *
   * @generated from field: uint32 count = 9;
   */
  count: number;
};

/**
 * Describes the message lvdr.v2.tasks.Recurrence.
 * Use `create(RecurrenceSchema)` to create a new message.
 */
export const RecurrenceSchema: GenMessage<Recurrence> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 2);

/**
 * TaskTemplate is the shape each materialised occurrence is stamped from.
 *
 * @generated from message lvdr.v2.tasks.TaskTemplate
 */
export type TaskTemplate = Message<"lvdr.v2.tasks.TaskTemplate"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string notes = 2;
   */
  notes: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskPriority priority = 3;
   */
  priority: TaskPriority;

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[];

  /**
   * @generated from field: uint32 estimate_min = 5;
   */
  estimateMin: number;

  /**
   * COS-23: copied onto every occurrence. A template has no snooze.
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel attention_level = 6;
   */
  attentionLevel: TaskAttentionLevel;
};

/**
 * Describes the message lvdr.v2.tasks.TaskTemplate.
 * Use `create(TaskTemplateSchema)` to create a new message.
 */
export const TaskTemplateSchema: GenMessage<TaskTemplate> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 3);

/**
 * @generated from message lvdr.v2.tasks.TaskSeries
 */
export type TaskSeries = Message<"lvdr.v2.tasks.TaskSeries"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;

  /**
   * @generated from field: lvdr.v2.tasks.Recurrence rule = 2;
   */
  rule?: Recurrence | undefined;

  /**
   * @generated from field: lvdr.v2.tasks.TaskTemplate template = 3;
   */
  template?: TaskTemplate | undefined;

  /**
   * The next scheduled occurrence.
   *
   * @generated from field: google.protobuf.Timestamp next_due = 4;
   */
  nextDue?: Timestamp | undefined;

  /**
   * Unset until the first materialisation.
   *
   * @generated from field: google.protobuf.Timestamp last_spawn = 5;
   */
  lastSpawn?: Timestamp | undefined;

  /**
   * Count of materialisations; doubles as the occurrence index in the
   * idempotence key, so it is consumed in SPAWN order, not slot order.
   *
   * @generated from field: uint32 spawned = 6;
   */
  spawned: number;

  /**
   * Occurrences skipped because the user was offline. A DISPLAY count, not a
   * work queue — the materialiser emits one task, never a backlog.
   *
   * @generated from field: uint32 missed = 7;
   */
  missed: number;

  /**
   * @generated from field: bool paused = 8;
   */
  paused: boolean;

  /**
   * Why the most recent materialisation failed. A failing series is skipped,
   * never fatal to the task list.
   *
   * @generated from field: string last_error = 9;
   */
  lastError: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.tasks.TaskSeries.
 * Use `create(TaskSeriesSchema)` to create a new message.
 */
export const TaskSeriesSchema: GenMessage<TaskSeries> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 4);

/**
 * @generated from message lvdr.v2.tasks.CreateSeriesRequest
 */
export type CreateSeriesRequest = Message<"lvdr.v2.tasks.CreateSeriesRequest"> & {
  /**
   * @generated from field: lvdr.v2.tasks.TaskTemplate template = 1;
   */
  template?: TaskTemplate | undefined;

  /**
   * @generated from field: lvdr.v2.tasks.Recurrence rule = 2;
   */
  rule?: Recurrence | undefined;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.CreateSeriesRequest.
 * Use `create(CreateSeriesRequestSchema)` to create a new message.
 */
export const CreateSeriesRequestSchema: GenMessage<CreateSeriesRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 5);

/**
 * @generated from message lvdr.v2.tasks.UpdateSeriesRequest
 */
export type UpdateSeriesRequest = Message<"lvdr.v2.tasks.UpdateSeriesRequest"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskTemplate template = 2;
   */
  template?: TaskTemplate | undefined;

  /**
   * An unset `rule` leaves the schedule alone. An empty `rule.timezone` carries
   * the STORED zone forward — re-resolving on edit would silently re-phase a
   * live series whenever the user's timezone setting changed.
   *
   * @generated from field: lvdr.v2.tasks.Recurrence rule = 3;
   */
  rule?: Recurrence | undefined;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 4;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.UpdateSeriesRequest.
 * Use `create(UpdateSeriesRequestSchema)` to create a new message.
 */
export const UpdateSeriesRequestSchema: GenMessage<UpdateSeriesRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 6);

/**
 * @generated from message lvdr.v2.tasks.ListSeriesRequest
 */
export type ListSeriesRequest = Message<"lvdr.v2.tasks.ListSeriesRequest"> & {
  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.ListSeriesRequest.
 * Use `create(ListSeriesRequestSchema)` to create a new message.
 */
export const ListSeriesRequestSchema: GenMessage<ListSeriesRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 7);

/**
 * Advance the series past its next occurrence without materialising it.
 *
 * @generated from message lvdr.v2.tasks.SkipOccurrenceRequest
 */
export type SkipOccurrenceRequest = Message<"lvdr.v2.tasks.SkipOccurrenceRequest"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.SkipOccurrenceRequest.
 * Use `create(SkipOccurrenceRequestSchema)` to create a new message.
 */
export const SkipOccurrenceRequestSchema: GenMessage<SkipOccurrenceRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 8);

/**
 * @generated from message lvdr.v2.tasks.PauseSeriesRequest
 */
export type PauseSeriesRequest = Message<"lvdr.v2.tasks.PauseSeriesRequest"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;

  /**
   * @generated from field: bool paused = 2;
   */
  paused: boolean;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.PauseSeriesRequest.
 * Use `create(PauseSeriesRequestSchema)` to create a new message.
 */
export const PauseSeriesRequestSchema: GenMessage<PauseSeriesRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 9);

/**
 * @generated from message lvdr.v2.tasks.DeleteSeriesRequest
 */
export type DeleteSeriesRequest = Message<"lvdr.v2.tasks.DeleteSeriesRequest"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.DeleteSeriesRequest.
 * Use `create(DeleteSeriesRequestSchema)` to create a new message.
 */
export const DeleteSeriesRequestSchema: GenMessage<DeleteSeriesRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 10);

/**
 * @generated from message lvdr.v2.tasks.SeriesResponse
 */
export type SeriesResponse = Message<"lvdr.v2.tasks.SeriesResponse"> & {
  /**
   * @generated from field: lvdr.v2.tasks.TaskSeries series = 1;
   */
  series?: TaskSeries | undefined;
};

/**
 * Describes the message lvdr.v2.tasks.SeriesResponse.
 * Use `create(SeriesResponseSchema)` to create a new message.
 */
export const SeriesResponseSchema: GenMessage<SeriesResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 11);

/**
 * @generated from message lvdr.v2.tasks.SeriesListResponse
 */
export type SeriesListResponse = Message<"lvdr.v2.tasks.SeriesListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.tasks.TaskSeries series = 1;
   */
  series: TaskSeries[];
};

/**
 * Describes the message lvdr.v2.tasks.SeriesListResponse.
 * Use `create(SeriesListResponseSchema)` to create a new message.
 */
export const SeriesListResponseSchema: GenMessage<SeriesListResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 12);

/**
 * @generated from message lvdr.v2.tasks.DeleteSeriesResponse
 */
export type DeleteSeriesResponse = Message<"lvdr.v2.tasks.DeleteSeriesResponse"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;
};

/**
 * Describes the message lvdr.v2.tasks.DeleteSeriesResponse.
 * Use `create(DeleteSeriesResponseSchema)` to create a new message.
 */
export const DeleteSeriesResponseSchema: GenMessage<DeleteSeriesResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 13);

/**
 * @generated from message lvdr.v2.tasks.CreateTaskRequest
 */
export type CreateTaskRequest = Message<"lvdr.v2.tasks.CreateTaskRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string notes = 2;
   */
  notes: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskPriority priority = 3;
   */
  priority: TaskPriority;

  /**
   * @generated from field: google.protobuf.Timestamp due = 4;
   */
  due?: Timestamp | undefined;

  /**
   * @generated from field: repeated string tags = 5;
   */
  tags: string[];

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 6;
   */
  workspaceId: string;

  /**
   * COS-23; UNSPECIFIED = not set
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel attention_level = 7;
   */
  attentionLevel: TaskAttentionLevel;

  /**
   * COS-23; unset = not snoozed
   *
   * @generated from field: google.protobuf.Timestamp snoozed_until = 8;
   */
  snoozedUntil?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.tasks.CreateTaskRequest.
 * Use `create(CreateTaskRequestSchema)` to create a new message.
 */
export const CreateTaskRequestSchema: GenMessage<CreateTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 14);

/**
 * @generated from message lvdr.v2.tasks.GetTaskRequest
 */
export type GetTaskRequest = Message<"lvdr.v2.tasks.GetTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.GetTaskRequest.
 * Use `create(GetTaskRequestSchema)` to create a new message.
 */
export const GetTaskRequestSchema: GenMessage<GetTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 15);

/**
 * @generated from message lvdr.v2.tasks.UpdateTaskRequest
 */
export type UpdateTaskRequest = Message<"lvdr.v2.tasks.UpdateTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskStatus status = 4;
   */
  status: TaskStatus;

  /**
   * @generated from field: lvdr.v2.tasks.TaskPriority priority = 5;
   */
  priority: TaskPriority;

  /**
   * @generated from field: google.protobuf.Timestamp due = 6;
   */
  due?: Timestamp | undefined;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * An unset `due` means "leave the due date alone", so it cannot express
   * "remove the due date" — same shape trap as proto3 repeated fields not being
   * able to wire an empty collection. This flag is the explicit clear signal;
   * when true the server drops the due date and ignores `due`.
   *
   * @generated from field: bool clear_due = 8;
   */
  clearDue: boolean;

  /**
   * estimate_min: 0 = "leave unchanged" (proto3 has no presence for scalars);
   * to remove an estimate send clear_estimate = true (mirrors clear_due).
   * Scheduled block times are NOT settable here — the planner owns them.
   *
   * @generated from field: uint32 estimate_min = 9;
   */
  estimateMin: number;

  /**
   * @generated from field: bool clear_estimate = 10;
   */
  clearEstimate: boolean;

  /**
   * An empty `notes` means "leave the description alone" (proto3 scalars have no
   * presence), so it cannot express "remove the description". This is the explicit
   * clear signal; when true the server empties notes and IGNORES `notes`.
   *
   * @generated from field: bool clear_notes = 11;
   */
  clearNotes: boolean;

  /**
   * Same trap for `priority`: UNSPECIFIED (0) means "leave it alone" on THIS
   * message. When true the server unsets the priority and IGNORES `priority`.
   *
   * @generated from field: bool clear_priority = 12;
   */
  clearPriority: boolean;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 13;
   */
  workspaceId: string;

  /**
   * COS-23. UNSPECIFIED leaves the attention level unchanged.
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel attention_level = 14;
   */
  attentionLevel: TaskAttentionLevel;

  /**
   * proto3 cannot tell "not sent" from UNSPECIFIED, so clearing the attention
   * level needs this flag. When true the server unsets it and IGNORES
   * `attention_level`.
   *
   * @generated from field: bool clear_attention_level = 15;
   */
  clearAttentionLevel: boolean;

  /**
   * COS-23. Unset leaves the snooze unchanged.
   *
   * @generated from field: google.protobuf.Timestamp snoozed_until = 16;
   */
  snoozedUntil?: Timestamp | undefined;

  /**
   * Unsnooze. When true the server clears the snooze and IGNORES `snoozed_until`.
   *
   * @generated from field: bool clear_snoozed_until = 17;
   */
  clearSnoozedUntil: boolean;
};

/**
 * Describes the message lvdr.v2.tasks.UpdateTaskRequest.
 * Use `create(UpdateTaskRequestSchema)` to create a new message.
 */
export const UpdateTaskRequestSchema: GenMessage<UpdateTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 16);

/**
 * @generated from message lvdr.v2.tasks.DeleteTaskRequest
 */
export type DeleteTaskRequest = Message<"lvdr.v2.tasks.DeleteTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.DeleteTaskRequest.
 * Use `create(DeleteTaskRequestSchema)` to create a new message.
 */
export const DeleteTaskRequestSchema: GenMessage<DeleteTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 17);

/**
 * @generated from message lvdr.v2.tasks.ListTasksRequest
 */
export type ListTasksRequest = Message<"lvdr.v2.tasks.ListTasksRequest"> & {
  /**
   * Unspecified = all open+in_progress. Set to filter to one status.
   *
   * @generated from field: lvdr.v2.tasks.TaskStatus status = 1;
   */
  status: TaskStatus;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.ListTasksRequest.
 * Use `create(ListTasksRequestSchema)` to create a new message.
 */
export const ListTasksRequestSchema: GenMessage<ListTasksRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 18);

/**
 * @generated from message lvdr.v2.tasks.TaskResponse
 */
export type TaskResponse = Message<"lvdr.v2.tasks.TaskResponse"> & {
  /**
   * @generated from field: lvdr.v2.tasks.Task task = 1;
   */
  task?: Task | undefined;
};

/**
 * Describes the message lvdr.v2.tasks.TaskResponse.
 * Use `create(TaskResponseSchema)` to create a new message.
 */
export const TaskResponseSchema: GenMessage<TaskResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 19);

/**
 * @generated from message lvdr.v2.tasks.TaskListResponse
 */
export type TaskListResponse = Message<"lvdr.v2.tasks.TaskListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.tasks.Task tasks = 1;
   */
  tasks: Task[];
};

/**
 * Describes the message lvdr.v2.tasks.TaskListResponse.
 * Use `create(TaskListResponseSchema)` to create a new message.
 */
export const TaskListResponseSchema: GenMessage<TaskListResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 20);

/**
 * @generated from message lvdr.v2.tasks.DeleteTaskResponse
 */
export type DeleteTaskResponse = Message<"lvdr.v2.tasks.DeleteTaskResponse"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;
};

/**
 * Describes the message lvdr.v2.tasks.DeleteTaskResponse.
 * Use `create(DeleteTaskResponseSchema)` to create a new message.
 */
export const DeleteTaskResponseSchema: GenMessage<DeleteTaskResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 21);

/**
 * Tags + links are mutated via dedicated single-item ops (not UpdateTaskRequest):
 * proto3 repeated fields can't express "clear to empty" over the wire, so a
 * replace-all update path cannot remove a task's last tag/link. Each op replies
 * with the full TaskResponse. (Phase 0b — task tags + cross-item links.)
 *
 * @generated from message lvdr.v2.tasks.AddTaskTagRequest
 */
export type AddTaskTagRequest = Message<"lvdr.v2.tasks.AddTaskTagRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string tag = 2;
   */
  tag: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.AddTaskTagRequest.
 * Use `create(AddTaskTagRequestSchema)` to create a new message.
 */
export const AddTaskTagRequestSchema: GenMessage<AddTaskTagRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 22);

/**
 * @generated from message lvdr.v2.tasks.RemoveTaskTagRequest
 */
export type RemoveTaskTagRequest = Message<"lvdr.v2.tasks.RemoveTaskTagRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string tag = 2;
   */
  tag: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.RemoveTaskTagRequest.
 * Use `create(RemoveTaskTagRequestSchema)` to create a new message.
 */
export const RemoveTaskTagRequestSchema: GenMessage<RemoveTaskTagRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 23);

/**
 * @generated from message lvdr.v2.tasks.LinkTaskRequest
 */
export type LinkTaskRequest = Message<"lvdr.v2.tasks.LinkTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskLink link = 2;
   */
  link?: TaskLink | undefined;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.LinkTaskRequest.
 * Use `create(LinkTaskRequestSchema)` to create a new message.
 */
export const LinkTaskRequestSchema: GenMessage<LinkTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 24);

/**
 * @generated from message lvdr.v2.tasks.UnlinkTaskRequest
 */
export type UnlinkTaskRequest = Message<"lvdr.v2.tasks.UnlinkTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string id = 3;
   */
  id: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 4;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.UnlinkTaskRequest.
 * Use `create(UnlinkTaskRequestSchema)` to create a new message.
 */
export const UnlinkTaskRequestSchema: GenMessage<UnlinkTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 25);

/**
 * TASKS-08 — "which tasks came from this note".
 *
 * Resolved by a SCAN (tasks.Service.TasksByLink), deliberately NOT a secondary
 * index: note.Service.NotesByTarget answers the mirror-image question the same
 * way, and an index would owe cleanup on every task-removal path. See
 * docs/plans/2026-08-17-notes-to-tasks-design.md.
 *
 * @generated from message lvdr.v2.tasks.ListTasksByLinkRequest
 */
export type ListTasksByLinkRequest = Message<"lvdr.v2.tasks.ListTasksByLinkRequest"> & {
  /**
   * link kind (any stored kind; writable kinds are tasks.linkKindsAllowed)
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * the link target's opaque id
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.ListTasksByLinkRequest.
 * Use `create(ListTasksByLinkRequestSchema)` to create a new message.
 */
export const ListTasksByLinkRequestSchema: GenMessage<ListTasksByLinkRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 26);

/**
 * TaskRef is the lightweight projection the panel renders — id + the three
 * fields a chip shows. Deliberately NOT a full Task: the panel lists clickable
 * references and must not ship task bodies. Mirrors notepb.NoteRef.
 *
 * status/priority are the EXISTING enums, not strings, so the FE reads one
 * vocabulary for these values rather than two.
 *
 * @generated from message lvdr.v2.tasks.TaskRef
 */
export type TaskRef = Message<"lvdr.v2.tasks.TaskRef"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskStatus status = 3;
   */
  status: TaskStatus;

  /**
   * @generated from field: lvdr.v2.tasks.TaskPriority priority = 4;
   */
  priority: TaskPriority;
};

/**
 * Describes the message lvdr.v2.tasks.TaskRef.
 * Use `create(TaskRefSchema)` to create a new message.
 */
export const TaskRefSchema: GenMessage<TaskRef> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 27);

/**
 * @generated from message lvdr.v2.tasks.ListTasksByLinkResponse
 */
export type ListTasksByLinkResponse = Message<"lvdr.v2.tasks.ListTasksByLinkResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.tasks.TaskRef tasks = 1;
   */
  tasks: TaskRef[];
};

/**
 * Describes the message lvdr.v2.tasks.ListTasksByLinkResponse.
 * Use `create(ListTasksByLinkResponseSchema)` to create a new message.
 */
export const ListTasksByLinkResponseSchema: GenMessage<ListTasksByLinkResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 28);

/**
 * COS-26 — one lazy suggestion pass over the caller's Private tasks. A non-empty
 * workspace_id (an always-on space) is refused.
 *
 * @generated from message lvdr.v2.tasks.SuggestTaskAttentionRequest
 */
export type SuggestTaskAttentionRequest = Message<"lvdr.v2.tasks.SuggestTaskAttentionRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.SuggestTaskAttentionRequest.
 * Use `create(SuggestTaskAttentionRequestSchema)` to create a new message.
 */
export const SuggestTaskAttentionRequestSchema: GenMessage<SuggestTaskAttentionRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 29);

/**
 * @generated from message lvdr.v2.tasks.TaskAttentionSkip
 */
export type TaskAttentionSkip = Message<"lvdr.v2.tasks.TaskAttentionSkip"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskAttentionSkipReason reason = 2;
   */
  reason: TaskAttentionSkipReason;
};

/**
 * Describes the message lvdr.v2.tasks.TaskAttentionSkip.
 * Use `create(TaskAttentionSkipSchema)` to create a new message.
 */
export const TaskAttentionSkipSchema: GenMessage<TaskAttentionSkip> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 30);

/**
 * @generated from message lvdr.v2.tasks.SuggestTaskAttentionResponse
 */
export type SuggestTaskAttentionResponse = Message<"lvdr.v2.tasks.SuggestTaskAttentionResponse"> & {
  /**
   * @generated from field: int32 suggested = 1;
   */
  suggested: number;

  /**
   * tasks still waiting after this pass
   *
   * @generated from field: int32 remaining = 2;
   */
  remaining: number;

  /**
   * @generated from field: repeated lvdr.v2.tasks.TaskAttentionSkip skipped = 3;
   */
  skipped: TaskAttentionSkip[];

  /**
   * @generated from field: bool daily_cap_reached = 4;
   */
  dailyCapReached: boolean;

  /**
   * @generated from field: int32 daily_max = 5;
   */
  dailyMax: number;

  /**
   * set when daily_cap_reached
   *
   * @generated from field: int32 retry_after_sec = 6;
   */
  retryAfterSec: number;

  /**
   * transient model errors (the pass stops at the first)
   *
   * @generated from field: int32 failed = 7;
   */
  failed: number;

  /**
   * @generated from field: int32 per_pass = 8;
   */
  perPass: number;
};

/**
 * Describes the message lvdr.v2.tasks.SuggestTaskAttentionResponse.
 * Use `create(SuggestTaskAttentionResponseSchema)` to create a new message.
 */
export const SuggestTaskAttentionResponseSchema: GenMessage<SuggestTaskAttentionResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 31);

/**
 * COS-26 — accept or reject the pending suggestion. Replies TaskResponse.
 *
 * @generated from message lvdr.v2.tasks.ResolveTaskAttentionSuggestionRequest
 */
export type ResolveTaskAttentionSuggestionRequest = Message<"lvdr.v2.tasks.ResolveTaskAttentionSuggestionRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: bool accept = 2;
   */
  accept: boolean;

  /**
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;

  /**
   * The level the user saw and approved. The server refuses (conflict) when the
   * pending suggestion is not this level: an approval is pinned, never re-derived.
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel expected_level = 4;
   */
  expectedLevel: TaskAttentionLevel;
};

/**
 * Describes the message lvdr.v2.tasks.ResolveTaskAttentionSuggestionRequest.
 * Use `create(ResolveTaskAttentionSuggestionRequestSchema)` to create a new message.
 */
export const ResolveTaskAttentionSuggestionRequestSchema: GenMessage<ResolveTaskAttentionSuggestionRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 32);

/**
 * Task priority P1 (highest) .. P4 (lowest).
 *
 * UNSPECIFIED (0) is DIRECTION- AND MESSAGE-DEPENDENT, deliberately:
 *   - CreateTaskRequest — "caller didn't say" => the server defaults to P3.
 *   - UpdateTaskRequest — "leave the priority alone"; to unset it send
 *                         clear_priority = true.
 *   - task RESPONSES    — "this task has no priority": a real stored state since
 *                         TASKS-18, which sorts and groups LAST.
 * It stopped meaning "P3 default" on responses the moment clear_priority existed.
 * Do not "simplify" this back: internal/tasks.priorityFromProto's P3 default arm
 * is the create contract and must stay, while priorityToProto's default arm is
 * UNSPECIFIED. The asymmetry IS the contract.
 *
 * @generated from enum lvdr.v2.tasks.TaskPriority
 */
export enum TaskPriority {
  /**
   * @generated from enum value: TASK_PRIORITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TASK_PRIORITY_P1 = 1;
   */
  P1 = 1,

  /**
   * @generated from enum value: TASK_PRIORITY_P2 = 2;
   */
  P2 = 2,

  /**
   * @generated from enum value: TASK_PRIORITY_P3 = 3;
   */
  P3 = 3,

  /**
   * @generated from enum value: TASK_PRIORITY_P4 = 4;
   */
  P4 = 4,
}

/**
 * Describes the enum lvdr.v2.tasks.TaskPriority.
 */
export const TaskPrioritySchema: GenEnum<TaskPriority> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 0);

/**
 * @generated from enum lvdr.v2.tasks.TaskStatus
 */
export enum TaskStatus {
  /**
   * @generated from enum value: TASK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TASK_STATUS_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: TASK_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: TASK_STATUS_DONE = 3;
   */
  DONE = 3,

  /**
   * @generated from enum value: TASK_STATUS_DROPPED = 4;
   */
  DROPPED = 4,
}

/**
 * Describes the enum lvdr.v2.tasks.TaskStatus.
 */
export const TaskStatusSchema: GenEnum<TaskStatus> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 1);

/**
 * Provenance of a task. v1 is manual; later COS phases add email/sweep/research.
 *
 * @generated from enum lvdr.v2.tasks.TaskSource
 */
export enum TaskSource {
  /**
   * @generated from enum value: TASK_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TASK_SOURCE_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * @generated from enum value: TASK_SOURCE_EMAIL = 2;
   */
  EMAIL = 2,

  /**
   * @generated from enum value: TASK_SOURCE_SWEEP = 3;
   */
  SWEEP = 3,

  /**
   * @generated from enum value: TASK_SOURCE_RESEARCH = 4;
   */
  RESEARCH = 4,
}

/**
 * Describes the enum lvdr.v2.tasks.TaskSource.
 */
export const TaskSourceSchema: GenEnum<TaskSource> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 2);

/**
 * COS-23. UNSPECIFIED = not set. It is a fourth state, never read as LIGHT.
 *
 * @generated from enum lvdr.v2.tasks.TaskAttentionLevel
 */
export enum TaskAttentionLevel {
  /**
   * @generated from enum value: TASK_ATTENTION_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TASK_ATTENTION_LEVEL_DEEP = 1;
   */
  DEEP = 1,

  /**
   * @generated from enum value: TASK_ATTENTION_LEVEL_LIGHT = 2;
   */
  LIGHT = 2,

  /**
   * @generated from enum value: TASK_ATTENTION_LEVEL_QUICK = 3;
   */
  QUICK = 3,
}

/**
 * Describes the enum lvdr.v2.tasks.TaskAttentionLevel.
 */
export const TaskAttentionLevelSchema: GenEnum<TaskAttentionLevel> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 3);

/**
 * RecurrenceAnchor decides what the NEXT occurrence is measured from.
 *
 * @generated from enum lvdr.v2.tasks.RecurrenceAnchor
 */
export enum RecurrenceAnchor {
  /**
   * @generated from enum value: RECURRENCE_ANCHOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Keep the schedule regardless of completion: "the 1st of every month" is the
   * 1st whether or not last month's task was done.
   *
   * @generated from enum value: RECURRENCE_ANCHOR_FIXED = 1;
   */
  FIXED = 1,

  /**
   * Measure from when the task was actually completed: "water the plants 3 days
   * after I last watered them". Such a series has AT MOST ONE open occurrence —
   * the materialiser suppresses while the previous one is still open.
   *
   * @generated from enum value: RECURRENCE_ANCHOR_COMPLETION = 2;
   */
  COMPLETION = 2,
}

/**
 * Describes the enum lvdr.v2.tasks.RecurrenceAnchor.
 */
export const RecurrenceAnchorSchema: GenEnum<RecurrenceAnchor> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 4);

/**
 * @generated from enum lvdr.v2.tasks.RecurrenceFreq
 */
export enum RecurrenceFreq {
  /**
   * @generated from enum value: RECURRENCE_FREQ_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RECURRENCE_FREQ_DAILY = 1;
   */
  DAILY = 1,

  /**
   * @generated from enum value: RECURRENCE_FREQ_WEEKLY = 2;
   */
  WEEKLY = 2,

  /**
   * @generated from enum value: RECURRENCE_FREQ_MONTHLY = 3;
   */
  MONTHLY = 3,

  /**
   * @generated from enum value: RECURRENCE_FREQ_YEARLY = 4;
   */
  YEARLY = 4,
}

/**
 * Describes the enum lvdr.v2.tasks.RecurrenceFreq.
 */
export const RecurrenceFreqSchema: GenEnum<RecurrenceFreq> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 5);

/**
 * @generated from enum lvdr.v2.tasks.TaskAttentionSkipReason
 */
export enum TaskAttentionSkipReason {
  /**
   * @generated from enum value: TASK_ATTENTION_SKIP_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TASK_ATTENTION_SKIP_REASON_CONFIDENTIAL = 1;
   */
  CONFIDENTIAL = 1,

  /**
   * @generated from enum value: TASK_ATTENTION_SKIP_REASON_FLOOR_UNKNOWN = 2;
   */
  FLOOR_UNKNOWN = 2,
}

/**
 * Describes the enum lvdr.v2.tasks.TaskAttentionSkipReason.
 */
export const TaskAttentionSkipReasonSchema: GenEnum<TaskAttentionSkipReason> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 6);

